export default defineNuxtPlugin(async () => {
  const user = useUser()

  if (import.meta.server) {
    // Anonymous public pages do not need an internal /api/me request. Besides
    // the unnecessary work, that private endpoint's no-store headers can be
    // forwarded to the outer SSR response and prevent public HTML caching.
    const token = useCookie('token')
    if (!token.value) {
      user.value = null
      return
    }

    try {
      const requestFetch = useRequestFetch()
      user.value = await requestFetch('/api/me')
    } catch {
      user.value = null
    }
    return
  }

  // SSR'dan gelen useState korunur; getUser istemci header'ini hazirlar.
  await getUser()
})
